import { render } from "./Leagues.vue?vue&type=template&id=1488b97a"
import script from "./Leagues.vue?vue&type=script&lang=js"
export * from "./Leagues.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__